export class NICEDialerCPASettings {
    abandonTimeout: number;
    abandonMessagePath: string;
    abandonMsgMode: number;
    ansMachineDetMode: number;
    ansMachineMsg: string;
    exceptions: any[];
    treatProgressAsRinging: boolean;
    preConnectCPAEnabled: boolean;
    agentOverrideOptionFax: boolean;
    agentOverrideOptionAnsweringMachine: boolean;
    agentOverrideOptionBadNumber: boolean;
    utteranceMinimumSeconds: number;
    customerLiveSilenceSeconds: number;
    machineMinimumWithAgentSeconds: number;
    machineMinimumWithoutAgentSeconds: number;
    machineEndSilenceSeconds: number;
    machineEndTimeoutSeconds: number;
    agentResponseUtteranceMinimumSeconds: number;
    agentNoResponseSeconds: number;
    agentVoiceThreshold: number;
    customerVoiceThreshold: number;
    preConnectCPARecording: boolean;
    enableCPALogging: boolean;
    ansMachineOverrideSeconds: number;


    constructor(jsonObject?) {
            this.abandonTimeout = +jsonObject?.abandonTimeout || 0;
            this.abandonMessagePath = jsonObject?.abandonMessagePath || '';
            this.abandonMsgMode = +jsonObject?.abandonMsgMode || 0;
            this.ansMachineDetMode = +jsonObject?.ansMachineDetMode || 0;
            this.ansMachineMsg = jsonObject?.ansMachineMsg || '';
            this.exceptions = jsonObject?.exceptions;
            this.treatProgressAsRinging = jsonObject?.treatProgressAsRinging || false;
            this.preConnectCPAEnabled = jsonObject?.preConnectCPAEnabled || false;
            this.agentOverrideOptionFax = jsonObject?.agentOverrideOptionFax || false;
            this.agentOverrideOptionAnsweringMachine = jsonObject?.agentOverrideOptionAnsweringMachine || false;
            this.agentOverrideOptionBadNumber = jsonObject?.agentOverrideOptionBadNumber || false;
            this.utteranceMinimumSeconds = +jsonObject?.utteranceMinimumSeconds || 0;
            this.customerLiveSilenceSeconds = +jsonObject?.customerLiveSilenceSeconds || 0;
            this.machineMinimumWithAgentSeconds = +jsonObject?.machineMinimumWithAgentSeconds || 0;
            this.machineMinimumWithoutAgentSeconds = +jsonObject?.machineMinimumWithoutAgentSeconds || 0;
            this.machineEndSilenceSeconds = +jsonObject?.machineEndSilenceSeconds || 0;
            this.machineEndTimeoutSeconds = +jsonObject?.machineEndTimeoutSeconds || 0;
            this.agentResponseUtteranceMinimumSeconds = +jsonObject?.agentResponseUtteranceMinimumSeconds || 0;
            this.agentNoResponseSeconds = +jsonObject?.agentNoResponseSeconds || 0;
            this.agentVoiceThreshold = +jsonObject?.agentVoiceThreshold || 0;
            this.customerVoiceThreshold = +jsonObject?.customerVoiceThreshold || 0;
            this.preConnectCPARecording = jsonObject?.preConnectCPARecording || false;
            this.enableCPALogging = jsonObject?.enableCPALogging || false;
            this.ansMachineOverrideSeconds = +jsonObject?.ansMachineOverrideSeconds || 0;
    }
}
